<script setup lang="ts">
import { ref } from "vue";
import type { MenuItem } from "primevue/menuitem";

interface Props {
  isSuperAdmin: boolean;
  isMultipleApps: boolean;
}

const props = defineProps<Props>()

const menu = ref();

const encodeToken = (token: string) => {
  return btoa(token);
};

//@ts-ignore
const queryString = `idToken=${encodeURIComponent(localStorage.getItem('idToken'))}&accessToken=${encodeURIComponent(localStorage.getItem('token'))}&refreshToken=${encodeURIComponent(localStorage.getItem('refreshToken'))}`;
const params = `/login?auth-callback=${encodeToken(queryString)}`


const toggle = (event: any) => {
  menu.value.toggle(event);
};
const devItemsAll = <MenuItem[]>[
  {
    label: 'Carbon Accounting',
    url: `http://localhost:5173${params}`
  },
  {
    label: 'Supply Chain',
    url: `http://localhost:5174${params}`
  },
  {
    label: 'Operations App',
    url: `http://localhost:5175${params}`
  }
];

const stageItemsAll = <MenuItem[]>[
  {
    label: 'Carbon Accounting',
    url: `https://app.${import.meta.env.VITE_APP_MODE}bono.eco${params}`
  },
  {
    label: 'Supply Chain',
    url: `https://supply-chain.${import.meta.env.VITE_APP_MODE}bono.eco${params}`
  },
  {
    label: 'Operations App',
    url: `https://operations.${import.meta.env.VITE_APP_MODE}bono.eco${params}`}
];

const devItems = props.isMultipleApps
  ? devItemsAll.filter(item => item.label !== 'Operations App')
  : devItemsAll;

const stageItems = props.isMultipleApps
  ? stageItemsAll.filter(item => item.label !== 'Operations App')
  : stageItemsAll;


const items = import.meta.env.DEV ? devItems : stageItems;

</script>

<template>
  <Button variant="outlined"
          icon="ri-apps-line"
          iconPos="right"
          @click="toggle"
          severity="contrast"
          aria-haspopup="true"
          aria-controls="overlay_menu"
  />
  <TieredMenu ref="menu" id="overlay_menu" :model="items" :popup="true" severity="contrast"  />
</template>
